import React, { useState } from 'react';
import { useCart } from '../context/CartContext';

// ── Drop your Stripe publishable key here when ready ────────────────────────
// const STRIPE_PK = process.env.REACT_APP_STRIPE_PK;

export default function Checkout() {
  const { items, total, clear } = useCart();
  const [form, setForm] = useState({ name: '', email: '', phone: '', address: '', city: '', zip: '' });
  const [submitted, setSubmitted] = useState(false);

  const set = (k: string) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm(f => ({ ...f, [k]: e.target.value }));

  // ── When Stripe is ready, replace this with a call to your backend ─────────
  // to create a Checkout Session and redirect to Stripe's hosted page.
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // TODO: await fetch('/api/create-checkout-session', { method: 'POST', body: JSON.stringify({ items, ...form }) })
    //   .then(r => r.json()).then(({ url }) => window.location.href = url);
    setSubmitted(true);
    clear();
  };

  if (submitted) {
    return (
      <div style={{ paddingTop: 64, minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 16, textAlign: 'center', padding: '64px 32px' }}>
        <div style={{ fontSize: 56 }}>✅</div>
        <h2 style={{ fontFamily: 'Bomber Dreams', fontSize: 44, letterSpacing: 2 }}>Order Received</h2>
        <p style={{ fontSize: 14, color: 'var(--muted)', lineHeight: 1.7, maxWidth: 420 }}>
          We'll confirm your order and reach out to <span style={{ color: 'var(--text)' }}>{form.email}</span> within 24 hours.
        </p>
      </div>
    );
  }

  return (
    <div style={{ paddingTop: 64 }}>
      <section style={{ padding: '60px 32px 80px' }}>
        <div style={{ maxWidth: 800, margin: '0 auto' }}>

          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div style={{
              fontFamily: 'DM Mono', fontSize: 18, letterSpacing: 4,
              color: 'var(--pink)', textTransform: 'uppercase', marginBottom: 12,
            }}>
              OG-TECH LLC
            </div>
            <h1 style={{ fontFamily: 'Bomber Dreams', fontSize: 'clamp(40px, 6vw, 64px)', letterSpacing: 2 }}>
              Checkout
            </h1>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 32 }} className="checkout-grid">

            {/* Form */}
            <form onSubmit={handleSubmit}>
              <div style={{
                fontFamily: 'DM Mono', fontSize: 13, letterSpacing: 3,
                color: 'var(--muted)', textTransform: 'uppercase', marginBottom: 20,
              }}>
                Your Info
              </div>

              {[
                { key: 'name', label: 'Full Name', type: 'text' },
                { key: 'email', label: 'Email', type: 'email' },
                { key: 'phone', label: 'Phone', type: 'tel' },
                { key: 'address', label: 'Street Address', type: 'text' },
                { key: 'city', label: 'City', type: 'text' },
                { key: 'zip', label: 'ZIP Code', type: 'text' },
              ].map(f => (
                <div key={f.key} style={{ marginBottom: 14 }}>
                  <label style={{
                    display: 'block', fontFamily: 'DM Mono', fontSize: 11,
                    letterSpacing: 2, color: 'var(--muted)', textTransform: 'uppercase', marginBottom: 6,
                  }}>
                    {f.label}
                  </label>
                  <input
                    type={f.type} required
                    value={(form as any)[f.key]}
                    onChange={set(f.key)}
                    style={{
                      width: '100%', background: '#090c12',
                      border: '1px solid var(--border)', borderRadius: 6,
                      color: 'var(--text)', fontFamily: 'DM Sans', fontSize: 15,
                      padding: '10px 12px', outline: 'none',
                    }}
                    onFocus={e => (e.target.style.borderColor = 'var(--pink)')}
                    onBlur={e => (e.target.style.borderColor = 'var(--border)')}
                  />
                </div>
              ))}

              {/* Payment placeholder */}
              <div style={{
                background: 'var(--card)', border: '1px dashed var(--border)',
                borderRadius: 8, padding: 20, marginTop: 20, marginBottom: 20, textAlign: 'center',
              }}>
                <div style={{ fontFamily: 'DM Mono', fontSize: 11, letterSpacing: 2, color: 'var(--muted)', textTransform: 'uppercase', marginBottom: 8 }}>
                  Payment
                </div>
                <div style={{ fontSize: 13, color: 'var(--muted)' }}>
                  Stripe integration drops in here when ready
                </div>
              </div>

              <button type="submit" style={{
                width: '100%', fontFamily: 'DM Mono', fontSize: 14, letterSpacing: 2,
                textTransform: 'uppercase', padding: '14px', borderRadius: 8,
                background: 'var(--pink)', color: '#000', border: 'none', cursor: 'pointer',
              }}>
                Place Order →
              </button>
            </form>

            {/* Order summary */}
            <div>
              <div style={{
                fontFamily: 'DM Mono', fontSize: 13, letterSpacing: 3,
                color: 'var(--muted)', textTransform: 'uppercase', marginBottom: 20,
              }}>
                Order Summary
              </div>
              <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 10, padding: 20 }}>
                {items.map(item => (
                  <div key={`${item.id}-${item.variant}`} style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '10px 0', borderBottom: '1px solid var(--border)',
                  }}>
                    <div>
                      <div style={{ fontSize: 14, marginBottom: 2 }}>{item.name}</div>
                      <div style={{ fontFamily: 'DM Mono', fontSize: 10, color: 'var(--muted)', letterSpacing: 1 }}>
                        {item.variant} · qty {item.qty}
                      </div>
                    </div>
                    <div style={{ fontFamily: 'Bomber Dreams', fontSize: 18, color: 'var(--teal)' }}>
                      ${(item.price * item.qty).toFixed(2)}
                    </div>
                  </div>
                ))}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 16 }}>
                  <span style={{ fontFamily: 'DM Mono', fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--muted)' }}>Total</span>
                  <span style={{ fontFamily: 'Bomber Dreams', fontSize: 30, color: 'var(--teal)' }}>${total.toFixed(2)}</span>
                </div>
              </div>
            </div>

          </div>

          <style>{`
            @media (max-width: 768px) { .checkout-grid { grid-template-columns: 1fr !important; } }
          `}</style>
        </div>
      </section>
    </div>
  );
}
